/**
 * Optimized Skeleton Loading - MAXIMUM PERFORMANCE
 * Minimal JavaScript, CSS-only animations
 */

// Lightweight skeleton loader
class OptimizedSkeleton {
  constructor() {
    this.init();
  }

  init() {
    // Use requestIdleCallback for non-blocking initialization
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => this.setupSkeleton());
    } else {
      setTimeout(() => this.setupSkeleton(), 0);
    }
  }

  setupSkeleton() {
    // Add skeleton to images that haven't loaded
    this.addImageSkeletons();
    
    // Setup intersection observer for lazy loading
    this.setupLazyLoading();
  }

  addImageSkeletons() {
    const images = document.querySelectorAll('img:not([data-skeleton-processed])');
    
    images.forEach(img => {
      img.setAttribute('data-skeleton-processed', 'true');
      
      if (!img.complete || img.naturalHeight === 0) {
        img.classList.add('skeleton-image');
        
        img.addEventListener('load', () => {
          img.classList.remove('skeleton-image');
        }, { once: true });
      }
    });
  }

  setupLazyLoading() {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadContent(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });

      // Observe skeleton containers
      document.querySelectorAll('.skeleton-container').forEach(el => {
        observer.observe(el);
      });
    }
  }

  loadContent(container) {
    // Simple fade-in without complex animations
    container.style.opacity = '0';
    container.style.transition = 'opacity 0.3s ease';
    
    requestAnimationFrame(() => {
      container.style.opacity = '1';
    });
  }

  // Create simple skeleton HTML
  createSkeleton(type, count = 1) {
    const skeletons = Array.from({ length: count }, () => {
      switch (type) {
        case 'product':
          return `
            <div class="skeleton-product-card">
              <div class="skeleton skeleton-image"></div>
              <div class="skeleton-content">
                <div class="skeleton skeleton-text short"></div>
                <div class="skeleton skeleton-text medium"></div>
                <div class="skeleton skeleton-button"></div>
              </div>
            </div>
          `;
        case 'text':
          return `
            <div class="skeleton-text-item">
              <div class="skeleton skeleton-text long"></div>
              <div class="skeleton skeleton-text medium"></div>
              <div class="skeleton skeleton-text short"></div>
            </div>
          `;
        default:
          return `<div class="skeleton skeleton-text medium"></div>`;
      }
    });

    return skeletons.join('');
  }
}

// Initialize only when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OptimizedSkeleton();
  });
} else {
  new OptimizedSkeleton();
}

// Export for global use
window.OptimizedSkeleton = OptimizedSkeleton;
